import {Contact} from '@/types'
import apiClient from '@/utils/axios'
import {AxiosResponse} from 'axios'

interface ContactService {
  add: (contactData: Contact) => Promise<AxiosResponse<Contact>>
}

const contact: ContactService = {
  async add(contactData: Contact): Promise<AxiosResponse<Contact>> {
    const response = await apiClient.post('/contact_forms', contactData)
    return response
  },
}

export {contact}
